<template>
    <div>
        <h1>{{ (!(alcors.length == 0 && import_data.length > 0) && no_access_alcors.length != alcors.length && !(alcors.includes('') && import_data.length > 0) && direct_execute != 2) ? "Configuration des fichiers salariés" : "Traitement des fichiers salariés" }}</h1>

        <a download href='https://alyx-asfortes.smartmydata.com/url/redirect/4158e95c-447a057b-e75134c3-773dae01-262ea9a0/documentation_interface_salaries_asfortes.pdf'>Télécharger l'aide</a>

        <div v-if="import_data.length == 0">
            Chargez un fichier salarié :
        </div>

        <div v-if="type_import_data == 'tabulator'">
			<edit_tabulator @update="import_file()" ref="tabulator"></edit_tabulator>
		</div>

        <div v-show="alcors.length == 0 && import_data.length > 0">
            Pas de colonne alcor. Chargez un fichier avec une colonne contenant alcor dans le nom.
        </div>
        <div v-show="alcors.includes('') && import_data.length > 0">
            Alcor vide pour certaines lignes. Chargez un fichier avec un alcor sur toutes les lignes.
        </div>

        <div v-show="!alcors.includes('') &&  alcors.length > 0 && no_access_alcors.length > 0">
            Vous n'avez pas les droits pour les alcors suivants : {{no_access_alcors.join(', ')}}
            <br /><br />
        </div>

        <div v-show="!alcors.includes('') && alcors.length > 0 && no_access_alcors.length == alcors.length">
            Chargez un fichier uniquement avec les concessions que vous avez en gestion.
            <br /><br />
        </div>

        <div v-show="!(alcors.length == 0 && import_data.length > 0) && no_access_alcors.length != alcors.length && !(alcors.includes('') && import_data.length > 0) && direct_execute == 2">
            <div v-show="data.length > 0">            
                <p><b>Statistiques</b></p>

                <p>Lignes incomplètes : {{data.length - stats_complete}}/{{(data.length)}}</p>

                <div v-for="(value, key) in stats" :key="key">
                    <div>Lignes avec la colonne {{key}} non remplie : {{value}}/{{data.length}}</div>
                </div>

                <p>
                    <br />
                    Le fichier n’a pas besoin d’être complet pour être traité, les valeurs manquantes seront à compléter directement dans les formulaires.
                </p>

            </div>

            <span v-b-tooltip.hover :title="!code_affaire_mapped ? 'La colonne Code affaire est obligatoire dans la configuration enregistrée' : ''" style="display:inline-block">
                <b-button variant="link" @click="execute(false)" :disabled="!code_affaire_mapped" :style="!code_affaire_mapped ? 'pointer-events:none' : ''">Démarrer le traitement du fichier avec la configuration enregistrée</b-button>
            </span><br />
            <b-button variant="link" @click="load();">Voir et modifier la configuration enregistrée</b-button>
        </div>

        <div v-show="!(alcors.length == 0 && import_data.length > 0) && no_access_alcors.length != alcors.length && !(alcors.includes('') && import_data.length > 0) && direct_execute != 2">
            <div v-if="load_alcor">La configuration pour l'alcor {{load_alcor}} a été chargée.<br /><br /></div>
            <div v-show="names.filter(value => alcors.includes(value)).length > 1 || (load_name != load_alcor && names.filter(value => alcors.includes(value)).length == 1)">
                <p>Une configuration existe pour :
                    <b-select v-model="load_name" :options="names.filter(value => alcors.includes(value))"></b-select>
                </p>
                <b-button variant="link" @click="load()">Charger la configuration</b-button>
            </div>

            <div v-show="alcors.filter(value => !names.includes(value) && !no_access_alcors.includes(value)).length > 0">
                Il n'existe pas de configuration pour les alcors : {{alcors.filter(value => !names.includes(value) && !no_access_alcors.includes(value)).join(", ")}}
            </div>

            <div v-show="names.filter(value => !alcors.includes(value)).length > 0 && import_data.length > 0">
                <br />
                <p>Autres configurations enregistrées :
                    <b-select v-model="load_name" :options="names.filter(value => !alcors.includes(value))"></b-select>
                </p>
                <b-button variant="link" @click="load();">Charger la configuration</b-button>
            </div>

            <br /><br />

            <h4>Configuration du fichier</h4>

            <div v-show="import_data.length > 0">

                <div v-for="(step, idx) in steps" :key="idx">
                    <div v-if="step.config.type == 'mapping_columns'">
                        <p><b>Mapping des colonnes</b></p>
                        <p v-if="step.config.legend">{{step.config.legend}}</p>
                        <b-container style="margin: 0; padding: 0; max-width: 600px">
                            <b-row v-for="(column, idx_column) in step.config.values" :key="idx_column">
                                <b-col v-if="column[0] != 'N° ALCOR'">
                                    <b-select @change="onColumnChange(step, column[0], $event)" v-model="step.columns[column[0]]" :options="[''].concat(columns)"></b-select>
                                </b-col>
                                <b-col v-else>
                                    <p style="padding-top:5px;padding-left:5px;margin-bottom:0">{{alcor_column}}</p>
                                </b-col>
                                <b-col>
                                    <div>{{column[0]}}<span v-if="column[0] == 'Code affaire'" style="color:red" title="Obligatoire"> *</span></div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                    <div v-if="step.config.type == 'mapping_cells'">
                        <p><b>Mapping des valeurs de la colonne {{step.config.column}}</b></p>
                        <p v-if="step.config.legend">{{step.config.legend}}</p>
                        <b-container style="margin: 0; padding: 0; max-width: 600px">
                            <b-row v-for="(value, idx_value) in step.values" :key="idx_value">
                                <b-col>
                                    <div>{{value.value_cell}}</div>
                                </b-col>
                                <b-col>
                                    <b-select v-model="value.value" :options="[''].concat(step.config.values_array)"></b-select>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                    <div v-if="step.config.type == 'rules'">
                        <b-button variant="link" v-b-toggle="'rules' + idx">{{step.config.libelle}}</b-button>
                        <p v-if="step.config.legend">{{step.config.legend}}</p>
                        <b-collapse :id="'rules' + idx">
                            <rules_block :ref="'rules' + idx" :columns="columns" :options="{
                                lowercase: false,
                                lists: [],
                                columns_list: {}
                            }" ></rules_block>
                            <b-button variant="link" @click="execute_code(step, idx)">Appliquer</b-button>
                        </b-collapse>
                    </div>
                    <hr />
                </div>
                <b-button @click="test()">Tester la configuration</b-button>
                <br /><br />

                <div v-show="data.length > 0">

                    <p><b>Statistiques</b></p>

                    <p>Lignes incomplètes : {{data.length - stats_complete}}/{{(data.length)}}</p>

                    <div v-for="(value, key) in stats" :key="key">
                        <div>Lignes avec la colonne {{key}} non remplie : {{value}}/{{data.length}}</div>
                    </div>

                    <p>
                        <br />
                        Le fichier n’a pas besoin d’être complet pour être traité, les valeurs manquantes seront à compléter directement dans les formulaires.
                    </p>

                    <edit_tabulator ref="tabulator_test" :extern_file="false" :editor="false" :download="false"></edit_tabulator>
                </div>

                <div v-show="alcors.length > 0">
                    <span v-b-tooltip.hover :title="!code_affaire_mapped ? 'La colonne Code affaire est obligatoire' : ''" style="display:inline-block">
                        <b-button @click="save" :disabled="!code_affaire_mapped" :style="!code_affaire_mapped ? 'pointer-events:none' : ''">Sauvegarder la configuration</b-button>
                    </span>
                </div>

                <br />

                <div v-show="import_data.length > 0 && alcors.length > 0">
                    <span v-b-tooltip.hover :title="!code_affaire_mapped ? 'La colonne Code affaire est obligatoire' : ''" style="display:inline-block">
                        <b-button @click="execute(true)" :disabled="!code_affaire_mapped" :style="!code_affaire_mapped ? 'pointer-events:none' : ''">Sauvegarder la configuration et démarrer le traitement du fichier</b-button>
                    </span>
                </div>

                <div v-if="alcors_nb > 0">
                    <b-progress-bar :variant="'info'" :value="100">
                        <span style="font-size: medium">{{alcors_nb}} sur {{alcors.length}} enregistrés</span>
                    </b-progress-bar>
                    <br />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import edit_tabulator from "../../components/edit_tabulator.vue";
	import rules_block from "../../components/rules_block.vue";
	import treatments from "../../services/treatments.js";
    import library from "../../services/library.js";
	import element from "../../services/element.js";
	import users from "../../services/users.js";
	import store from "../../store";

    import * as json2csv from "json2csv";
    import moment from "moment";
	import alasql from "alasql";
	import __ from 'lodash';

    const removeAccents = require('remove-accents-diacritics');
	var clone = require("clone");

    export default {
		components: {
            edit_tabulator,
            rules_block
		},
		data() {
			return {
                name: "",
                names: [],
                load_name: "",
                import_data: [],
                type_import_data: "tabulator",
                config: {},
                config_obj: {},
                steps: [],
                columns: [],
                step_mapping_column: 0,
                step_mapping_cells: {},
                code: "",
                data: [],
                alcors: [],
                alcors_nb: 0,
                direct_execute: 0,
                loading: false,
                executing_code: false,
                project: null,
                load_alcor: "",
                stats: {},
                stats_complete: 0,
                alcor_column: "",
                no_access_alcors: [],
                code_affaire_mapped: false
            }
        },
        methods: {
            async execute(save = false)
            {
                var errors = false;
                if (save)
                   errors = await this.save();

                /*if (errors)
                {
                    this.$notify({
                        group: "info",
                        title: "Le traitement a été stoppé car votre fichier contient un ou des N°ALCOR en dehors de vos droits.",
                        type: "error",
                        duration: -1
                    });
                    
                    return;
                }*/

                var formdata = new FormData();

                var data = clone(this.import_data)

                if (store.state.user.rules && store.state.user.rules.library_type && store.state.user.rules.library_type.mapping_salaries)
                {
                    for (var k = 0; k < data.length; k++)
                    {
                        data[k].name = data[k][this.alcor_column];
                    }
                    var compiled = __.template(store.state.user.rules.library_type.mapping_salaries);
                    store.state.user.rules.library_type.mapping_salaries = compiled({data: store.state.user.details, user: store.state.user})
                    data = alasql("SELECT * FROM ? WHERE " + store.state.user.rules.library_type.mapping_salaries, [data]);
                }

                var csv = json2csv.parse(data, {
                    fields: Object.keys(data[0]),
                    fieldNames: Object.keys(data[0]),
                });
                csv = new Blob([csv], {
                    type: "text/plain",
                });

                treatments
                    .create(
                        this.project,
                        null,
                        csv,
                        "data.csv",
                        null,
                        "import",
                        formdata
                    )
                    .then((res) => {
                        this.$router.push({
                            name: "treatment",
                            params: { id: res.treatment.uid },
                        });
                    }).catch((err) => {
                        console.log("error : " + err);
                        this.$notify({
                            group: "info",
                            title: err.response.data.msg,
                            type: "error",
                        });
                    });
            },
            async load(import_data = false)
            {
                console.log("load : " + this.load_name)
                this.loading = true
                var self = this;

                this.load_alcor = this.load_name;

                var data = await library.load(
                    this.load_name,
                    null,
                    "mapping_salaries"
                );

                console.log(data)

                this.name = data.name;
                if (import_data)
                    this.import_data = data.import_data || [];
                this.type_import_data = data.type_import_data;
                this.columns = data.columns || [];

                var data_step_obj = {};
                for (var i = 0; i < data.steps.length; i++)
                {
                    data_step_obj[data.steps[i].config.name] = i;
                }

                //this.steps = [];
                if (data.steps)
                {
                    for (var i = 0; i < this.steps.length; i++)
                    {
                        console.log("step " + i)
                        console.log(clone(this.steps[i]))
                        if (data_step_obj.hasOwnProperty(this.steps[i].config.name))
                        {
                            var config = clone(this.steps[i].config);
                            this.steps[i] = data.steps[data_step_obj[this.steps[i].config.name]];
                            this.steps[i].config = config;
                            if (this.steps[i].config && this.steps[i].config.type == "rules")
                                await this.$refs['rules' + i][0].load(data.steps[data_step_obj[this.steps[i].config.name]].rules);
                        }
                        else if (this.config_obj[this.steps[i].config.name])
                            this.steps[i].config = this.config_obj[this.steps[i].config.name];
                        console.log(clone(this.steps[i]))
                    }
                }
                else
                {
                    for (var i = 0; i < this.config.length; i++)
                    {
                        var step = {
                            config: clone(this.config[i]),
                            columns: {},
                            values: [],
                            values_keys: []
                        };
                        if (import_data)
                            step.data = clone(this.import_data)
                        this.steps.push();
                    }
                    console.log("steps")
                    console.log(this.steps)
                }

                if (!import_data)
                    await this.import_file(this.import_data);

                self.$nextTick(async function () {
                    if (import_data)
    					self.$refs.tabulator.load(data.import_data);
                });
                
                console.log("import_data")
                console.log(import_data)

                if (!import_data)
                {
                    this.loading = false;
                    console.log("import_data false")
                }
            },
            async load_config_step(step)
            {
                console.log("load step")

                if (!step.values)
                    step.values = [];

                step.values_obj = {};
                step.values_array = [];

                for (var i = 0; i < step.values.length; i++)
                {
                    if (step.values[i] == "")
                    {
                        step.values.splice(i, 1);
                        i--;
                    }
                    else
                    {
                        step.values[i] = step.values[i].split(step.separator || "")
                        for (var j = 0; j < step.values[i].length; j++)
                        {
                            if (j == 0)
                                step.values_array.push(step.values[i][j].trim());
                            step.values[i][j] = step.values[i][j].trim();
                            step.values_obj[removeAccents.remove(step.values[i][j].toLowerCase().trim().replace(/ /g, ""))] = step.values[i][0].trim();
                        }
                    }
                }

                if (step.list)
                {
                    var list = await element.getby_production("list", step.list);
                    if (list.element && list.element.length > 0)
                    {
                        var list = await element.load(
                            list.element[0].libelle,
                            list.element[0].version,
                            "list"
                        );
                        for (var i = 0; i < list.list.length; i++)
                        {
                            var values = []
                            for (var j = 0; j < list.list[i].words.length; j++)
                            {
                                var value = list.list[i].words[j].text;
                                if (j == 0)
                                    step.values_array.push(value);
                                values.push(value)
                                step.values_obj[removeAccents.remove(value.toLowerCase().trim().replace(/ /g, ""))] = values[0];
                            }
                            step.values.push(values);
                        }
                    }
                }

                console.log(step)
            },
            async test()
            {
                this.code = await this.generate_code();

                var f = new Function('data', this.code);
                this.data = clone(this.import_data);
                
                if (store.state.user.rules && store.state.user.rules.library_type && store.state.user.rules.library_type.mapping_salaries)
                {
                    for (var k = 0; k < this.data.length; k++)
                    {
                        this.data[k].name = this.data[k][this.alcor_column];
                    }
                    var compiled = __.template(store.state.user.rules.library_type.mapping_salaries);
                    store.state.user.rules.library_type.mapping_salaries = compiled({data: store.state.user.details, user: store.state.user})
                    this.data = alasql("SELECT * FROM ? WHERE " + store.state.user.rules.library_type.mapping_salaries, [this.data]);
                }
                
                for (var i = 0; i < this.data.length; i++)
                {
                    this.data[i] = f(this.data[i]);
                }

                this.$refs.tabulator_test.load(this.data);

                this.stats = {};
                this.stats_complete = 0;

                var keys = Object.keys(this.data.length > 0 ? this.data[0] : []);
                for (var i = 0; i < this.data.length; i++)
                {
                    var nb = 0;
                    for (var j = 0; j < keys.length; j++)
                    {
                        if (!this.data[i][keys[j]])
                        {
                            nb++;
                            if (!this.stats[keys[j]])
                                this.stats[keys[j]] = 0;
                            this.stats[keys[j]]++;
                        }
                    }
                    if (nb == 0)
                        this.stats_complete++;
                }
            },
            async execute_code(step, idx)
            {
                var code = await this.generate_code_step(step, idx);
                code += "return data;";

                var f = new Function('data', code);

                var data = clone(this.import_data);
                if (idx > 0)
                    data = clone(this.steps[idx - 1].data);
                for (var i = 0; i < data.length; i++)
                {
                    data[i] = f(data[i]);
                }
                step.data = data;

                this.executing_code = true;

                for (var i = idx + 1; i < this.steps.length; i++)
                {
                    this.steps[i].data = clone(step.data);
                    if (this.steps[i].config.type == "mapping_columns")
                        this.import_columns(this.steps[i]);
                    else if (this.steps[i].config.type == "mapping_cells")
                        this.import_cell(this.steps[i]);
                }

                this.executing_code = false;
            },
            async generate_code_step(step, idx)
            {
                var code = "";
                if (step.config.type == "rules")
                    code = await this.$refs['rules' + idx][0].generate_code();
                else if (step.config.type == "mapping_columns")
                {
                    code = "data={"
                    for (var i = 0; i < step.config.values.length; i++)
                    {
                        if (step.columns[step.config.values[i][0]])
                            code += `"${step.config.values[i][0]}":data["${step.columns[step.config.values[i][0]]}"],`;
                        else
                            code += `"${step.config.values[i][0]}":"",`;
                    }
                    code += "};";
                }
                else if (step.config.type == "mapping_cells")
                {
                    code += `data["${step.config.column}"] = data["${step.config.column}"] ? data["${step.config.column}"].trim() : "";switch(data["${step.config.column}"]){`
                    for (var i = 0; i < step.values.length; i++)
                    {
                        if (step.values[i].value)
                        {
                            code += 
                            `case "${step.values[i].value_cell}":data["${step.config.column}"]="${step.values[i].value}";break;`;
                        }
                        else
                        {
                            code += 
                            `case "${step.values[i].value_cell}":data["${step.config.column}"]="";break;`;
                        }
                    }
                    code += `};`;
                }

                return code;
            },
            async generate_code()
            {
                var code = "";

                for (var i = 0; i < this.steps.length; i++)
                {
                    code += await this.generate_code_step(this.steps[i], i);
                }
                code += "return data;";

                return code;
            },
            async save()
            {
                var data = {
                    name: this.name,
                    import_data: this.import_data,
                    type_import_data: this.type_import_data,
                    steps: clone(this.steps),
                    columns: this.columns,
                    code: ""
                }

                for (var i = 0; i < data.steps.length; i++)
                {
                    if (data.steps[i].config.type == "rules")
                        data.steps[i].rules = await this.$refs['rules' + i][0].save();
                }

                data.code = await this.generate_code();

                console.log(data)

                var data_db = {
                    alcors: this.alcors
                }

                this.alcors_nb = 0;
                var errors = 0;

                for (var i = 0; i < this.alcors.length; i++)
                {
                    if (this.alcors[i])
                    {
                        if (!this.no_access_alcors.includes(this.alcors[i]))
                        {
                            try
                            {
                                await library.save(
                                    this.alcors[i],
                                    "1",
                                    data,
                                    "mapping_salaries",
                                    false,
                                    data_db,
                                    true
                                );
                            }
                            catch (err)
                            {
                                this.$notify({
                                    group: "info",
                                    title: "Une erreur c'est produite pour l'alcor " + this.alcors[i],
                                    type: "error",
                                });
                                errors++;
                            }
                        }
                    }
                    else
                    {
                        this.$notify({
                            group: "info",
                            title: "Alcor vide",
                            type: "error",
                        });
                        errors++;
                    }

                    this.alcors_nb++;
                }
                this.alcors_nb = 0;
                
                this.$notify({
					group: "info",
					title: "Enrgistrement effectué",
					type: "success",
                });
                
                var names = await library.getby_production("mapping_salaries");
                names = names.element;

                this.names = [];
                for (var i = 0; i < names.length; i++) {
                    this.names.push(names[i].name);
                }

                return errors ? true : false;
            },
			async import_file(import_data = null)
			{
                console.log("import_file")
                this.import_data = import_data ? import_data : this.$refs.tabulator.get_data();

                var data = clone(this.import_data); 

                this.columns = Object.keys(this.import_data[0]).sort();

                for (var i = 0; i < this.steps.length; i++)
                {
                    this.steps[i].data = clone(data);
                }

                for (var i = 0; i < this.steps.length; i++)
                {
                    if (this.steps[i].config.type == "mapping_columns")
                    {
                        this.import_columns(this.steps[i])
                    }
                    else if (this.steps[i].config.type == "mapping_cells")
                    {
                        this.import_cell(this.steps[i])
                    }
                    else if (this.steps[i].config.type == "rules")
                    {
                        await this.execute_code(this.steps[i], i);
                    }
                }
                console.log(this.steps);
                console.log(this.loading)

                await this.test();

                if (this.loading)
                {
                    this.loading = false;
                    if (!this.direct_execute)
                        this.direct_execute = 1;
                    else
                        this.direct_execute++;
                }

                if (this.load_alcor == "" && this.load_name && this.names.includes(this.load_name))
                    this.load();
                                
            },
            import_columns(step)
            {
                console.log("import_column");
                console.log(clone(step))
                this.columns = Object.keys(step.data[0]);

                console.log(this.columns)
                console.log(step.config.values_obj)

                this.alcors = [];
                for (var j = 0; j < this.columns.length; j++)
                {
                    if (step.config.values_obj[removeAccents.remove(this.columns[j].toLowerCase().replace(/ /g, "").trim())]
                        && !step.columns[step.config.values_obj[removeAccents.remove(this.columns[j].toLowerCase().replace(/ /g, "").trim())]])
                    {
                        step.columns[step.config.values_obj[removeAccents.remove(this.columns[j].toLowerCase().replace(/ /g, "").trim())]] = this.columns[j];
                    }
                    if (removeAccents.remove(this.columns[j].replace(/ /g, "").toLowerCase().trim()).includes("alcor"))
                    {
                        this.no_access_alcors = [];
                        this.alcor_column = this.columns[j];
                        // Toujours forcer la mise à jour de N° ALCOR vers la colonne détectée
                        step.columns["N° ALCOR"] = this.columns[j];
                        for (var k = 0; k < step.data.length; k++)
                        {
                            if (!this.alcors.includes(step.data[k][this.columns[j]]))
                                this.alcors.push(step.data[k][this.columns[j]]);
                        }
                        if (this.alcors.length > 0)
                            this.load_name = this.alcors[0];
                        else
                            this.load_name = "";
                        if (store.state.user.rules && store.state.user.rules.library_type && store.state.user.rules.library_type.mapping_salaries)
                        {
                            this.load_name = "";
                            var data = clone(step.data);
                            for (var k = 0; k < data.length; k++)
                            {
                                data[k].name = data[k][this.alcor_column];
                            }
                            console.log("filters");
                            var compiled = __.template(store.state.user.rules.library_type.mapping_salaries);
                            store.state.user.rules.library_type.mapping_salaries = compiled({data: store.state.user.details, user: store.state.user})
                            console.log(store.state.user.rules.library_type.mapping_salaries)
                            console.log(step.data)
                            var result = alasql("SELECT * FROM ? WHERE " + store.state.user.rules.library_type.mapping_salaries, [data]);
                            console.log(result)
                            var result_alcor = result.map(a => a[this.alcor_column]);
                            for (var k = 0; k < this.alcors.length; k++)
                            {
                                if (!result_alcor.includes(this.alcors[k]))
                                    this.no_access_alcors.push(this.alcors[k]);
                                else if (!this.load_name)
                                    this.load_name = this.alcors[k];
                            }
                        }
                        if (!this.loading && !this.executing_code)
                        {
                            if (this.alcors.filter(value => !this.names.includes(value) && !this.no_access_alcors.includes(value)).length == 0)
                            {
                                if (!this.direct_execute)
                                    this.direct_execute = 1;
                                else
                                    this.direct_execute++;
                            }
                            else
                                this.direct_execute = false;
                        }
                    }
                }
                var keys = Object.keys(step.columns)
                for (var i = 0; i < keys.length; i++)
                {
                    if (!this.columns.includes(step.columns[keys[i]]))
                        this.columns.push(step.columns[keys[i]]);
                }

                this.columns = this.columns.sort();

                var stepIdx = this.steps.indexOf(step);
                if (stepIdx >= 0) {
                    this.steps[stepIdx].columns = Object.assign({}, step.columns);
                }
                // Mise à jour explicite de code_affaire_mapped
                this.code_affaire_mapped = !!(step.columns && step.columns['Code affaire']);
                console.log('[import_columns] stepIdx =', stepIdx, 'Code affaire =', step.columns['Code affaire'], '→ code_affaire_mapped =', this.code_affaire_mapped);
            },
            onColumnChange(step, columnName, value)
            {
                // import_cell si nécessaire
                if (this.step_mapping_cells.hasOwnProperty(columnName))
                    this.import_cell(this.steps[this.step_mapping_cells[columnName]]);
                // Mise à jour explicite de code_affaire_mapped
                var mappingStep = this.steps[this.step_mapping_column];
                if (mappingStep) {
                    var newVal = (columnName === 'Code affaire') ? value : mappingStep.columns['Code affaire'];
                    this.code_affaire_mapped = !!newVal;
                    console.log('[onColumnChange] colonne =', columnName, 'valeur =', value, '→ code_affaire_mapped =', this.code_affaire_mapped);
                }
            },
            import_cell(step)
            {
                console.log("import_cell")
                console.log(step)
                var column = step.config.column;

                var step_column = this.steps[this.step_mapping_column];
                if (step_column.columns[column])
                    column = step_column.columns[column];

                var values_keys = [];
                var values = [];

                for (var i = 0; i < step.values.length; i++)
                {
                    if (step.values[i].value)
                    {
                        values_keys.push(step.values[i].value_cell.trim());
                        console.log(step.values[i])
                        values.push(step.values[i]);
                    }
                }

                for (var i = 0; i < step.data.length; i++)
                {
                    if (i == 0 && !step.data[i].hasOwnProperty(column))
                    {
                        return;
                    }
                    if (!values_keys.includes(step.data[i][column].trim()))
                    {
                        var value = "";

                        if (step.config.values_obj[removeAccents.remove(step.data[i][column].toLowerCase().replace(/ /g, "").trim())])
                            value = step.config.values_obj[removeAccents.remove(step.data[i][column].toLowerCase().replace(/ /g, "").trim())];

                        values_keys.push(step.data[i][column].trim());
                        values.push({
                            value_cell: step.data[i][column].trim(),
                            value: value.trim()
                        });
                    }
                }

                step.values_keys = values_keys
                step.values = values;

                step.values = step.values.sort((a, b) => a.value_cell < b.value_cell ? -1 : 1);
            }
        },
		mounted: async function () {

            var self = this;

			var response = await users.getSelf(true);
			let client = response.client;

            if (!(client.details && client.details.pages && client.details.pages.gcr && client.details.pages.gcr.active))
            {
                this.$router.push({ name: "profile" });
            }

            this.project = client.details.pages.gcr.project;

            if (store.state.user.rules && !store.state.user.rules.library) {
                if (!store.state.user.rules.library_type.mapping_salaries && !store.state.user.rules.library_type)
    				this.$router.push({ name: "profile" });
            }

            var result = await library.getby_production(
                "config",
                "mapping"
            );

            if (typeof result.element[0].data === "string")
                result.element[0].data = JSON.parse(result.element[0].data)

            this.config = result.element[0].data.config.mapping;
            for (var i = 0; i < this.config.length; i++)
            {
                await this.load_config_step(this.config[i]);
                this.config_obj[this.config[i].name] = this.config[i];
            }

            for (var i = 0; i < this.config.length; i++)
            {
                if (this.config[i].type == "mapping_columns")
                    this.step_mapping_column = i;
                else if (this.config[i].type == "mapping_cells")
                    this.step_mapping_cells[this.config[i].column] = i;
                
                this.steps.push({
                    config: clone(this.config[i]),
                    columns: {},
                    values: [],
                    values_keys: [],
                    data: []
                });
            }

            console.log("steps")
            console.log(this.steps)

            var names = await library.getby_production("mapping_salaries");
            names = names.element;

            this.names = [];
            for (var i = 0; i < names.length; i++) {
                this.names.push(names[i].name);
            }

            if (this.import_data.length > 0)
                this.import_file()
        }
    }
</script>

<style scoped>
</style>